<template>
  <teleport to="#modals">
    <div v-if="showModal" class="fixed inset-0 z-50 flex items-center justify-center">
      <transition
          @after-leave="showModal = false"
          enter-active-class="ease-out duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="ease-in duration-200"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
      >
        <div v-show="showBackdrop">
          <div class="absolute inset-0 bg-black opacity-70" @click="close"></div>
        </div>
      </transition>

      <transition
          @after-leave="showBackdrop = false"
          enter-active-class="ease-out duration-300"
          enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-from-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div v-show="showContent" class="relative w-4/5">
          <img :src="src" class="object-contain w-full rounded max-h-9/10 max-w-9/10" :alt="alt" @click="close()">
        </div>
      </transition>
    </div>
  </teleport>
</template>

<script>
export default {
  emits: ['close'],
  props: {
    'src': String,
    'alt': String
  },
  data() {
    return {
      showModal: false,
      showBackdrop: false,
      showContent: false,
      onEscape: null
    }
  },
  created() {
    this.onEscape = (e) => {
      if (this.showModal && e.keyCode === 27) {
        this.close()
      }
    }
    document.addEventListener('keydown', this.onEscape)
  },
  unmounted(){
    document.removeEventListener('keydown', this.onEscape)
  },
  methods: {
    show() {
      this.showModal = true
      setTimeout(() => {
        this.showBackdrop = true
        this.showContent = true
      }, 1)
    },
    close() {
      this.showContent = false
    }
  }
}
</script>
